import { api } from '../api'
import type { Drill, DrillUpdate, DrillSequenceUpdate } from '@acepoker/contract'

export const updateDrill = async (
  drillId: Drill['id'],
  drillTemplate: {
    drill: DrillUpdate
    sequence?: DrillSequenceUpdate | null
  }
): Promise<{ id: Drill['id'] }> =>
  await api().url(`/api/drill/${drillId}`).put(drillTemplate).json()
